import { useContext } from 'react';
import { useGeneralRoutes } from '@namespace/cms';
import { LocalizedRedirect } from '@namespace/i18n';
import { useSearchParams } from '@namespace/router';
import { USER_ROLES, UserContext, useUserInfoLoaded } from '@namespace/user';
import { RestrictedScreen } from './RestrictedScreen';

export const PromotionsWidget = () => {
  const [user = {}] = useContext(UserContext);
  const { role } = user;
  const { promotions } = useGeneralRoutes();
  const { userInfoLoaded } = useUserInfoLoaded();
  const { sErrorCode } = useSearchParams();

  if (userInfoLoaded) {
    if (role === USER_ROLES.GUEST) {
      return <LocalizedRedirect to={promotions} />;
    }

    if (sErrorCode) {
      return <RestrictedScreen errorCode={Number(sErrorCode)} />;
    }
  }

  return null;
};
